import { RequestStatusEnum } from '../lib/enums';
import { dateFormat } from '../lib/utils';
import dayjs from 'dayjs';
import { BaseModel, PageableResponse } from './index';

export interface PurchaseRequest {
  id: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  code: string;
  timeCreated: string;
  timeUpdated: string;
  active: boolean;
  requiredDate: string;
  source: string;
  notes: string;
  vendor: BaseModel;
  destination: BaseModel;
  status: string;
  prLocation: BaseModel;
}
export interface PurchaseRequestRecord {
  id: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  code: string;
  timeCreated: string;
  timeUpdated: string;
  active: boolean;
  requiredDate: string;
  source: string;
  notes: string;
  vendor: BaseModel;
  destination: BaseModel;
  status: RequestStatusEnum;
  prLocation: BaseModel;
  /** Who asked, for which buyer, by when. */
  requestedBy?: string;
  buyer?: BaseModel;
  dateNeeded?: string;
  requestLines: RequestLineRecord[];
}

export interface PurchaseRequestForm {
  files?: any;
  id: string;
  code: string;
  requiredDate: string;
  source?: string;
  notes?: string;
  status?: string;
  /** Who asked, for which buyer, by when -- the head of the request form. */
  requestedBy?: string;
  buyer?: BaseModel | undefined;
  dateNeeded?: string | null;
  destination: BaseModel | undefined;
  requestLines: RequestLineForm[];
}

export interface RequestLineForm {
  id: string;
  uuid: string;
  description: string;
  product: BaseModel | undefined;
  quantity: number;
  productUom?: BaseModel | undefined;

  // --- specification sheet, per requested material -------------------------
  // The workbook's NEW MATERIAL REQUEST FORM. Empty for materials purchasing
  // already knows; filled in when the request is for something new.
  specification?: string;
  size?: string;
  length?: string;
  width?: string;
  height?: string;
  diameter?: string;
  circumference?: string;
  density?: string;
  thickness?: string;
  otherMeasurements?: string;
  testsRequired?: string;
  purpose?: string;
  sampleNeeded?: boolean;
  sampleDateNeeded?: string | null;
  sampleQtyMinimum?: number;
  sampleQtyExcess?: number;
  specialConsiderations?: string;
  printingInstruction?: string;
  supportMaterial?: string;
}

export interface RequestLineRecord {
  id: string;
  uuid: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  timeCreated: string;
  timeUpdated: string;
  active: boolean;
  proder: string;
  sku: string;
  pono: string;
  product: BaseModel;
  description: string;
  quantity: number;
  productUom: BaseModel;
  status: string;
  unitPrice: number;
  specification?: string;
  size?: string;
  length?: string;
  width?: string;
  height?: string;
  diameter?: string;
  circumference?: string;
  density?: string;
  thickness?: string;
  otherMeasurements?: string;
  testsRequired?: string;
  purpose?: string;
  sampleNeeded?: boolean;
  sampleDateNeeded?: string;
  sampleQtyMinimum?: number;
  sampleQtyExcess?: number;
  specialConsiderations?: string;
  printingInstruction?: string;
  supportMaterial?: string;
}

export const initialData: PageableResponse<PurchaseRequest> = {
  start: 1,
  length: 99999,
  recordsTotal: 0,
  recordsFiltered: 1,
  data: [],
};
export const initialPurchaseRequestForm = {
  id: '',
  code: '',
  files: '',
  requiredDate: dayjs(new Date()).format(dateFormat),
  source: '',
  notes: '',
  status: RequestStatusEnum.DRAFT,
  destination: undefined,
  requestLines: [],
};

export const PRNextStatus = (prStatus?: RequestStatusEnum | undefined) => {
  let newStatus: any;
  switch (prStatus) {
    case 'DRAFT':
      newStatus = 'CONFIRM';
      break;
    case 'CONFIRM':
      newStatus = 'APPROVED';
      break;
    default:
      newStatus = prStatus;
      break;
  }
  return newStatus;
};

// detail
export interface PurchaseRequestDetails {
  id: string;
  logRevisionId: string;
  createdBy: string;
  updatedBy: string;
  timeCreated: string;
  timeUpdated: string;
  active: boolean;
  prNo: string;
  requiredDate: string;
  proder: string;
  sku: string;
  productCode: string;
  productName: string;
  description: string;
  quantity: number;
  quantityPO: number;
  quantityReceived: number;
  productUom: string;
  status: string;
}

export interface PurchaseRequestDetailFilter {
  from: string | null;
  to: string | null;
  proder?: string | null | undefined;
  sku?: string | null | undefined;
  product?: string | null | undefined;
  destination: string | null | undefined;
  datepicker?: (string | null)[];
}
